// extracted by mini-css-extract-plugin
export default {"term":"AcknowledgeTermsModalContent_term__PauyI"};